import { makeStyles } from '@material-ui/core';
import { FC, useEffect, useState } from 'react';
import Garbage from 'src/asset/garbage.svg';
import CButton from 'src/component/Button';
import Modal from 'src/component/Modal/Modal';
import ModalInputGroup from 'src/component/ModalInputGroup';
import { UrlPrefixType } from 'src/page/DynamicLinksConfig/interfaces/urlPrefixType.interface';

const useStyle = makeStyles({
  garbage: {
    cursor: 'pointer',
    left: '24px',
    position: 'absolute'
  }
});

interface AddOrEditUrlPrefixModalProps {
  handleClose: () => void;
  handleCreate: (e: MouseEvent) => void;
  handleDelete?: (e: MouseEvent) => void;
  handleEdit?: (e: MouseEvent) => void;
  initialInputGroupValue?: string;
  inputGroupDescription?: string;
  inputGroupError?: string;
  inputGroupHtmlFor: string;
  inputGroupLabel: string;
  inputGroupOnChange: (value: string) => void;
  inputGroupValue: string;
  isOpen: boolean;
  urlType: UrlPrefixType;
}

const AddOrEditUrlPrefixModal: FC<AddOrEditUrlPrefixModalProps> = ({
  handleClose,
  handleCreate,
  handleDelete,
  handleEdit,
  initialInputGroupValue,
  inputGroupDescription,
  inputGroupError,
  inputGroupHtmlFor,
  inputGroupLabel,
  inputGroupOnChange,
  inputGroupValue,
  isOpen,
  urlType
}) => {
  const classes = useStyle();

  const [isDeleting, setIsDeleting] = useState(false);

  const [isEditing, setIsEditing] = useState(!!initialInputGroupValue);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    setIsDeleting(false);
  }, [isOpen]);

  useEffect(() => {
    setIsEditing(!!initialInputGroupValue);
  }, [initialInputGroupValue]);

  if (isDeleting) {
    return (
      <Modal
        footerActions={
          <>
            <CButton
              onClick={() => setIsDeleting(false)}
              type="secondary"
              xstyle={{ height: '40px' }}
            >
              Cancel
            </CButton>

            <CButton onClick={handleDelete} type="primary" xstyle={{ height: '40px' }}>
              Delete
            </CButton>
          </>
        }
        handleClose={() => setIsDeleting(false)}
        isModalOpen={isOpen}
        styles={{
          // @ts-ignore
          '& .MuiDialogContent-root': {
            paddingTop: '0px'
          },
          width: '480px'
        }}
        titleContent={<h3 className="modal-title">Delete Dynamic Link</h3>}
      >
        <h3>
          Are you sure you want to delete this {urlType} URL prefix ({initialInputGroupValue})? You
          can&apos;t undo this action.
        </h3>
      </Modal>
    );
  }

  return (
    <Modal
      footerActions={
        <>
          {isEditing && (
            <img
              alt={`delete ${urlType} link URL prefix button`}
              className={classes.garbage}
              onClick={() => setIsDeleting(true)}
              src={Garbage}
            />
          )}

          <CButton onClick={handleClose} type="secondary" xstyle={{ height: '40px' }}>
            Cancel
          </CButton>

          {isEditing ? (
            <CButton
              htmlType="submit"
              onClick={handleEdit}
              type="primary"
              xstyle={{ height: '40px' }}
            >
              Edit
            </CButton>
          ) : (
            <CButton
              htmlType="submit"
              onClick={handleCreate}
              type="primary"
              xstyle={{ height: '40px' }}
            >
              Create
            </CButton>
          )}
        </>
      }
      handleClose={handleClose}
      isModalOpen={isOpen}
      styles={{
        // @ts-ignore
        '& .MuiDialogContent-root': {
          height: '220px',
          paddingTop: '0px'
        },
        width: '480px'
      }}
      titleContent={
        <h3 className="modal-title">
          {`${isEditing ? 'Edit' : 'Create new'} ${urlType} URL prefix`}
        </h3>
      }
    >
      <ModalInputGroup
        description={inputGroupDescription}
        error={inputGroupError}
        htmlFor={inputGroupHtmlFor}
        label={inputGroupLabel}
        onChange={inputGroupOnChange}
        value={inputGroupValue}
      />
    </Modal>
  );
};

export default AddOrEditUrlPrefixModal;
